import React, { useMemo } from 'react'
import useCurrentUser from '../utils/useCurrentUser';

const IfAuthNonMemoed = ({ roleCodes = [], children = null, alt = null, condition = true }) => {
    if (!(roleCodes instanceof Array)) {
        roleCodes = [roleCodes];
    }

    const user = useCurrentUser();

    const roleClaims = useMemo(
        () => user?.roles?.map((userRole) => userRole?.role?.code?.toUpperCase()),
        [user?.roles]
    );

    const claimsIntersection = useMemo(
        () => roleCodes.filter(roleCode => roleClaims?.includes(roleCode?.toUpperCase())),
        [roleCodes, roleClaims]
    );

    return user && condition && (roleCodes?.length === 0 || claimsIntersection?.length > 0)
        ? children
        : alt;
}

const IfAuth = React.memo(IfAuthNonMemoed);
export default IfAuth;